import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { Observable, forkJoin, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { constantStrings, APINames } from '../helpers/constants';
import { SharedStateService } from '@shared/services/shared-state.service';

@Injectable({
  providedIn: 'root',
})
export class ApiprocedureService {
  private readonly baseUrl: string = environment.backendUrl;
  private readonly baseUrlDev: string = environment.baseUrl;
  private readonly baseUrlLogger: string = environment.backendUrlLogger;
  private readonly baseAdminUrlClp: string = environment.baseAdminUrlClp;
  private readonly baseUrlCLP: string = environment.baseUrlCLP;
  private readonly baseUrlDUU: string = environment.baseUrlDUU;
  private getCaseDetailsAPI: string = this.baseUrl + '/casedetails';
  private getFacilityAPI: string = this.baseUrlDev + '/imageupload/facility';
  private getCaseDBDetailsAPI: string = this.baseUrl + '/casedashboard';
  private updateCaseDetailsAPI: string = this.baseUrl + '/updatecasedetails';
  private editDueDateAPI: string = this.baseUrl + '/duedate';
  private filterValuesImageAPI: string = this.baseUrl + '/filtervaluesimaging';
  private filterValuesClaimantAPI: string = this.baseUrl + '/filtervaluesclaimant';
  private filterValuesCaseDBAPI: string = this.baseUrl + '/filtervalues';
  private exportAuditlogsDateAPI: string = this.baseUrlLogger + '/exportselectedlog';
  private auditlogmetadata: string = this.baseUrlLogger + '/auditlogmetadata';
  private downloadauditlog: string = this.baseUrlLogger + '/downloadauditlog';
  private exportAuditlogAPI: string = this.baseUrlLogger + '/exportlog';
  private auditLogActivityAPI: string = this.baseUrlLogger + '/auditlog';
  private loggedInDetailsClpAPI: string = this.baseAdminUrlClp + '/imageupload/loggedinuserdetails';
  private getFacilityCLPAPI: string = this.baseUrlCLP + '/imageupload/facility';
  private editPersmissionAPI: string = this.baseUrl + '/editpermission'; 
private auditLogInDUUAPI: string = this.baseUrlDUU + '/imageupload/auditlog';


  httpHeaders: any;
  private httpOptions: any;
  errMsg: string;
  userInfo: any;
  auditAction: any;
  action: { caseId: any; userName: any; action: string; dateTime: number; eventOutCome: number; eventType: string};
  actionActivityDetails: any;
  errUserDetails: any;
  errorLog: string;
  eventOutcome: number;
  eventType: string;

  constructor(
    private http: HttpClient,
    private sharedState: SharedStateService,
  ) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe(response => {
      this.auditAction = response;
    });
  }

  public getCasedetails(caseId): any {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('caseId', caseId);
    return this.http
      .get(this.getCaseDetailsAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.CaseDetails))));
  }
  public getFacilityDetails(facilityIds): any {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('facilityIds', facilityIds);
    return this.http
      .get(this.getFacilityCLPAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.Facility))));
  }
  public getCaseDBDetails(params): any {
    return this.http
      .post(this.getCaseDBDetailsAPI, params)
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.CaseDB))));
  }

  public getExportAuditLogsDateService(selectedStart, selectedEnd): any {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('startDate', selectedStart);
    queryParams = queryParams.append('endDate', selectedEnd);

    return this.http.get<{ fileSize: number, auditLogFileName : any }>(this.auditlogmetadata, { params: queryParams }).pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.Export))));
  }
  
  public getDownloadAuditLogsDateService(fileName, ranges): any {
    let queryParam = new HttpParams();
    queryParam = queryParam.append('fileName', fileName);
    const downloadChunks = ranges.map((range, ind) => {
        return this.http.get(this.downloadauditlog, {
            headers: { 'Range': `bytes=${range.start}-${range.end}` },
            responseType: 'blob',
            params: queryParam
        });
    });

    return forkJoin(downloadChunks);
  }


  public exportAuditLogService(caseId): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('caseId', caseId);
    return this.http
      .get(this.exportAuditlogAPI, {responseType: 'blob', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.Export))));
  }
  public updateCaseDetails(params): Observable<any> {
    return this.http
      .put(this.updateCaseDetailsAPI, params)
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.CaseDetails))));
  }
  public editDueDate(params): Observable<any> {
    return this.http
      .put(this.editDueDateAPI, params)
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.EditDueDate))));
  }
  public getFilterValuesImage(statusCode): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('statuscode', statusCode);
    return this.http
      .get(this.filterValuesImageAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.FilterValue))));
  }
  public getFilterValuesClaimant(statuscodes, casecategory): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('statuscodes', statuscodes);
    queryParams = queryParams.append('casecategory', casecategory);
    return this.http
      .get(this.filterValuesClaimantAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.FilterValue))));
  }
  public getFilterValuesCaseDB(userName): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('userName', userName);
    return this.http
      .get(this.filterValuesCaseDBAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.FilterValue))));
  }
  public getLoggedInDetails(userName): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('username', userName);
    return this.http
      .get(this.loggedInDetailsClpAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError(this.handleError));
  }
  public checkEditPermission(caseId,action): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('caseId', caseId);
    queryParams = queryParams.append('buttonAction', action);
    return this.http
      .get(this.editPersmissionAPI, { observe: 'body', responseType: 'json', params: queryParams })
      .pipe(catchError((err) => (this.auditLogActivityStore(err, APINames.FilterValue))));
  }
  fetchTokenCode(code, vId): Observable<any> {
    const params = `grant_type=authorization_code&client_id=${environment.userPoolWebClientId}&code=${code}&code_verifier=${vId}&redirect_uri=${environment.hilCloudFrontSigninUrl}`;
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    return this.http.post(environment.hostedUIUrl + 'token', params, { headers }).pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse): any {
    let errMsg: string;    
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errMsg = 'An error occurred:' + error.error.message;
    } else {
      const statusCode = 400;
      if (error.status === statusCode) {
        errMsg = error.error.errorMessage;
      } else {
        errMsg = constantStrings.APIHANDLEERROR;
      }
      this.errorLog = `Backend returned code ${error.status}, ` + `body was: ${error.error}`;
    }
    return throwError(errMsg);
  }
  public auditLogActivity(params): any {
    return this.http.post(this.auditLogActivityAPI, params)
      .pipe(catchError(this.handleError));
  }
  public auditLogInDUU(params): any {
    return this.http.post(this.auditLogInDUUAPI, params)
      .pipe(catchError(this.handleError));
  }

  public auditLogActivityStore(error: HttpErrorResponse, name) {
    if (error.error instanceof ErrorEvent) {
      this.errMsg = 'An error occurred:' + error.error.message;
    } else {
      const statusCode = 400;
      if (error.status === statusCode) {
        this.errMsg = error.error.errors[0];
      } else {
        this.errMsg = constantStrings.APIHANDLEERROR;
      }
    }
    this.action = {
      "caseId": this.userInfo.caseId,
      "userName": this.userInfo.username,
      "dateTime": this.userInfo.dateTime,
      "action": this.auditAction.UserActions.sysException + name + " " + this.errMsg,
      "eventOutCome": this.eventOutcome ? 1 : 0,
      "eventType": this.eventType
    }
    this.auditLogActivity(this.action).subscribe({
      next: result => { 
          this.actionActivityDetails = result;
      }, error: err => {
          this.errUserDetails = err;
      }
    });
    return throwError(this.errMsg);
  }

 
  
  




}